import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from '../../pages/main/components/header/header'
import Footer from '../../pages/main/components/footer/footer'

function MainRoute() {
  const location = useLocation()
  
  // Check if current route is project detail page
  const isProjectDetail = location.pathname.startsWith('/projects/')
  
  return (
    <div className={isProjectDetail ? 'bg-gradient-to-br from-sky-50 to-blue-50' : ''}>
      <div className=''>
        <Header />
      </div>
      <Outlet />
      <div>
        <Footer/>
      </div>
    </div>
  )
}

export default MainRoute
